/**
 * EffortSelector — selector segmentado 1-5 de esfuerzo percibido.
 *
 * s53.2 (E.1): extraído VERBATIM del markup inline del modal post-sesión
 * de SessionDetailPage para reutilizarlo en el mini-modal "Marcar" de
 * SessionCard sin duplicar. Mismos estilos, testids parametrizables.
 */

export interface EffortSelectorProps {
  value: number | null;
  /** Recibe el nuevo valor (o null si el usuario des-selecciona el
   *  mismo botón — comportamiento del modal de detalle). */
  onChange: (value: number | null) => void;
  label: string;
  /** Prefijo de data-testid por instancia ("ps-effort" en detalle,
   *  "mark-effort" en el mini-modal de la card). */
  testIdPrefix: string;
}

export function EffortSelector({
  value,
  onChange,
  label,
  testIdPrefix,
}: EffortSelectorProps) {
  return (
    <div className="flex flex-col gap-1">
      <span className="text-xs uppercase tracking-widest text-gray-mid">
        {label}
      </span>
      <div className="flex gap-2" role="group" aria-label={label}>
        {[1, 2, 3, 4, 5].map((n) => (
          <button
            key={n}
            type="button"
            data-testid={`${testIdPrefix}-${n}`}
            aria-pressed={value === n}
            onClick={() => onChange(value === n ? null : n)}
            className={`flex-1 rounded-md border px-0 py-2 text-sm transition-colors duration-fast ${
              value === n
                ? "border-lime bg-lime/15 text-lime"
                : "border-border-subtle text-bone-muted hover:border-border-strong"
            }`}
          >
            {n}
          </button>
        ))}
      </div>
    </div>
  );
}
